<template>
  <div>
    <div id="richText" v-html="dataHtml">
    </div>
    <modal-infos v-show="isModalVisible"
               @close="closeModal"
                 :text="contents"
                 v-if="Object.keys(contents).length && contents['edges'].length"
    />
  </div>
</template>

<script>
  import ModalInfos from "../Modal/Models/Modal-infos";
  import gql from 'graphql-tag'

  import { mapActions } from 'vuex'

  export default {
    name: "RichText",
    components: {ModalInfos},
    apollo: {
      contents: {
        query: gql` query contents($slug: String) {
          contents(slug: $slug) {
              edges {
                node {
                      title,
                      body,
                    }
                }
            }
        }`,
        variables() {
          // Use vue reactive properties here
          return {
            slug: this.slug
          }
        },
      }
    },

    data () {
      return {
        isModalVisible: false,
        contents: {},
        slug: ''
      };
    },
    props: ["dataHtml"],
    methods: {
      showModal() {
        this.isModalVisible = true;
      },
      closeModal() {
        this.isModalVisible = false;
      },
      request() {
        return this.contents;
      },
      ...mapActions({
        setModalContactVisible: 'setModalContactVisible'
      })
    },
    updated() {
      var that = this;

      if(this.$el.getElementsByTagName('a').length && this.$el.getElementsByClassName('popin').length) {
        var link = this.$el.getElementsByClassName('popin')[0];
        var linkUrl = link.href;
        this.slug = linkUrl.substring(linkUrl.lastIndexOf("/")+1);
        link.addEventListener("click", (e) => {
          e.preventDefault()
          this.request()
          this.showModal()
        });
      }

      var contactTriggers = document.querySelectorAll("a[href='#contact-trigger']");
      contactTriggers.forEach(function(link) {
        link.addEventListener('click', (e) => {
          e.preventDefault()
          that.setModalContactVisible(true)
        });
      });
    }
  }
</script>

<style scoped>

</style>